/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const AgentCompactionContextManagementType = {
  Compaction: "compaction",
} as const;
export type AgentCompactionContextManagementType = ClosedEnum<
  typeof AgentCompactionContextManagementType
>;

export type AgentCompactionContextManagement = {
  type: AgentCompactionContextManagementType;
  /**
   * The token threshold above which conversation context should be compacted. Must be at least 1000.
   */
  compactThreshold: number;
};

/** @internal */
export const AgentCompactionContextManagementType$inboundSchema:
  z.ZodNativeEnum<typeof AgentCompactionContextManagementType> = z.nativeEnum(
    AgentCompactionContextManagementType,
  );
/** @internal */
export const AgentCompactionContextManagementType$outboundSchema:
  z.ZodNativeEnum<typeof AgentCompactionContextManagementType> =
    AgentCompactionContextManagementType$inboundSchema;

/** @internal */
export const AgentCompactionContextManagement$inboundSchema: z.ZodType<
  AgentCompactionContextManagement,
  z.ZodTypeDef,
  unknown
> = z.object({
  type: AgentCompactionContextManagementType$inboundSchema,
  compact_threshold: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    "compact_threshold": "compactThreshold",
  });
});
/** @internal */
export type AgentCompactionContextManagement$Outbound = {
  type: string;
  compact_threshold: number;
};

/** @internal */
export const AgentCompactionContextManagement$outboundSchema: z.ZodType<
  AgentCompactionContextManagement$Outbound,
  z.ZodTypeDef,
  AgentCompactionContextManagement
> = z.object({
  type: AgentCompactionContextManagementType$outboundSchema,
  compactThreshold: z.number().int(),
}).transform((v) => {
  return remap$(v, {
    compactThreshold: "compact_threshold",
  });
});

export function agentCompactionContextManagementToJSON(
  agentCompactionContextManagement: AgentCompactionContextManagement,
): string {
  return JSON.stringify(
    AgentCompactionContextManagement$outboundSchema.parse(
      agentCompactionContextManagement,
    ),
  );
}
export function agentCompactionContextManagementFromJSON(
  jsonString: string,
): SafeParseResult<AgentCompactionContextManagement, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => AgentCompactionContextManagement$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'AgentCompactionContextManagement' from JSON`,
  );
}
